<app-student-module ModuleName='Appropriate Instruction' (Save)="save(f)" [SaveHidden]='false'
                    [SaveDisabled]="f.form.pristine" (ExtraButton)="toggleLegacy()"
                    [ExtraButtonLabel]="'Display Legacy'"
                    [ExtraButtonHidden]="oldModel === null" [ExtraButtonClasses]="'btn-primary'"
                    [ExtraButtonDisabled]='false'
                    [PrintOptions]="printOptions">
  <form #f="ngForm">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-6">Highly Qualified</div>
        <div class="col">
          <input type="checkbox" class="checkbox" [(ngModel)]="model.highly_qualified" name="highly_qualified"/>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">Curriculum based on CCSS?</div>
        <div class="col">
          <input type="checkbox" class="checkbox" [(ngModel)]="model.curriculum_based" name="curriculum_based"/>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">Teacher trained in curriculum</div>
        <div class="col">
          <input type="checkbox" class="checkbox" [(ngModel)]="model.teacher_trained" name="teacher_trained"/>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">Curriculum implemented in fidelity</div>
        <div class="col">
          <input type="checkbox" class="checkbox" [(ngModel)]="model.curriculum_fidelity" name="curriculum_fidelity"/>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6">Student attended 85%</div>
        <div class="col">
          <input type="checkbox" class="checkbox" [(ngModel)]="model.attended_eightyfive" name="attended_eightfive"/>
        </div>
      </div>
    </div>
    <div class="container-fluid" *ngIf="oldModel !== null" [ngClass]="{ hideLegacy: !displayLegacy }">
      <nav class="navbar d-print-none">
        <span class="navbar-brand">Legacy Appropriate Instruction</span>
      </nav>
      <h3 class="d-none d-print-block" [ngClass]="{ 'd-print-none': !printOptions.getValue('display.headers') }">Legacy
        Appropriate Instructions</h3>
      <div class="card mb-2">
        <div class="card-header">Basic Reading</div>
        <div class="card-body">
          <table class="table">
            <tr>
              <td>High Qualified</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.br_hq)"></i></td>
            </tr>
            <tr>
              <td>Curriculum based on CCSS?</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.br_glce)"></i></td>
            </tr>
            <tr>
              <td>Teacher trained in curriculum</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.br_curriculum)"></i>
              </td>
            </tr>
            <tr>
              <td>Curriculum implemented in fidelity</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.br_fidelity)"></i>
              </td>
            </tr>
            <tr>
              <td>Student attended 85%</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.br_attendance)"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-header">Reading Fluency</div>
        <div class="card-body">
          <table class="table">
            <tr>
              <td>High Qualified</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.rf_hq)"></i></td>
            </tr>
            <tr>
              <td>Curriculum based on CCSS?</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.rf_glce)"></i></td>
            </tr>
            <tr>
              <td>Teacher trained in curriculum</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.rf_curriculum)"></i>
              </td>
            </tr>
            <tr>
              <td>Curriculum implemented in fidelity</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.rf_fidelity)"></i>
              </td>
            </tr>
            <tr>
              <td>Student attended 85%</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.rf_attendance)"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-header">Reading Competancy</div>
        <div class="card-body">
          <table class="table">
            <tr>
              <td>High Qualified</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.rc_hq)"></i></td>
            </tr>
            <tr>
              <td>Curriculum based on CCSS?</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.rc_glce)"></i></td>
            </tr>
            <tr>
              <td>Teacher trained in curriculum</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.rc_curriculum)"></i>
              </td>
            </tr>
            <tr>
              <td>Curriculum implemented in fidelity</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.rc_fidelity)"></i>
              </td>
            </tr>
            <tr>
              <td>Student attended 85%</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.rc_attendance)"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-header">Writing Expression</div>
        <div class="card-body">
          <table class="table">
            <tr>
              <td>High Qualified</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.we_hq)"></i></td>
            </tr>
            <tr>
              <td>Curriculum based on CCSS?</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.we_glce)"></i></td>
            </tr>
            <tr>
              <td>Teacher trained in curriculum</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.we_curriculum)"></i>
              </td>
            </tr>
            <tr>
              <td>Curriculum implemented in fidelity</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.we_fidelity)"></i>
              </td>
            </tr>
            <tr>
              <td>Student attended 85%</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.we_attendance)"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-header">Matd Calculations</div>
        <div class="card-body">
          <table class="table">
            <tr>
              <td>High Qualified</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.mc_hq)"></i></td>
            </tr>
            <tr>
              <td>Curriculum based on CCSS?</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.mc_glce)"></i></td>
            </tr>
            <tr>
              <td>Teacher trained in curriculum</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.mc_curriculum)"></i>
              </td>
            </tr>
            <tr>
              <td>Curriculum implemented in fidelity</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.mc_fidelity)"></i>
              </td>
            </tr>
            <tr>
              <td>Student attended 85%</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.mc_attendance)"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-header">Matd Problem Solving</div>
        <div class="card-body">
          <table class="table">
            <tr>
              <td>High Qualified</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.mp_hq)"></i></td>
            </tr>
            <tr>
              <td>Curriculum based on CCSS?</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.mp_glce)"></i></td>
            </tr>
            <tr>
              <td>Teacher trained in curriculum</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.mp_curriculum)"></i>
              </td>
            </tr>
            <tr>
              <td>Curriculum implemented in fidelity</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.mp_fidelity)"></i>
              </td>
            </tr>
            <tr>
              <td>Student attended 85%</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.mp_attendance)"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-header">Listening Competancy</div>
        <div class="card-body">
          <table class="table">
            <tr>
              <td>High Qualified</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.lc_hq)"></i></td>
            </tr>
            <tr>
              <td>Curriculum based on CCSS?</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.lc_glce)"></i></td>
            </tr>
            <tr>
              <td>Teacher trained in curriculum</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.lc_curriculum)"></i>
              </td>
            </tr>
            <tr>
              <td>Curriculum implemented in fidelity</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.lc_fidelity)"></i>
              </td>
            </tr>
            <tr>
              <td>Student attended 85%</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.lc_attendance)"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-header">Oral Expression</div>
        <div class="card-body">
          <table class="table">
            <tr>
              <td>High Qualified</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.oe_hq)"></i></td>
            </tr>
            <tr>
              <td>Curriculum based on CCSS?</td>
              <td><i class="fa fa-check" (hide)="(!oldModel.oe_glce)"></i></td>
            </tr>
            <tr>
              <td>Teacher trained in curriculum</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.oe_curriculum)"></i>
              </td>
            </tr>
            <tr>
              <td>Curriculum implemented in fidelity</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.oe_fidelity)"></i>
              </td>
            </tr>
            <tr>
              <td>Student attended 85%</td>
              <td>
                <i class="fa fa-check" (hide)="(!oldModel.oe_attendance)"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </form>
</app-student-module>
